// extracted by mini-css-extract-plugin
export default {"feedReveal":"index_feedReveal_7LrDI","articleReveal":"index_articleReveal_5vAIv","revealBox":"index_revealBox_n-j6F"};